import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const modules = require.context("../modules", true, /^.*\.routes.js$/);

export default new VueRouter({
  routes: [
    ...modules.keys().reduce((r, key) => r.concat(modules(key).default), [])
  ]
});
